import React from 'react'
import { BrowserRouter as Router,Switch, Route, Link } from 'react-router-dom'; 
import Header from '../components/Header'

function Home(props) {
    return (

        <div>
                <Header />
               
                <div className="Card-container">

                <Link className="Cat-card" to="/ghuda">Browser Extensions</Link>
                <Link className="Cat-card" to="/test">Test</Link>
                <Link className="Cat-card" to="/ghuda">File Converter</Link>
                <Link className="Cat-card" to="/ghuda">Web Tools</Link>
                <Link className="Cat-card" to="/ghuda">Recommended Apps</Link>
                <Link className="Cat-card" to="/ghuda">Newsletter</Link>
                <Link className="Cat-card" to="/ghuda">AI Websites</Link>
                <Link className="Cat-card" to="/ghuda">Telegram Bots</Link>
                </div>
          
        </div>
  
    )
}

export default Home
